import type { WorkSession } from '@/types/workSession.type';
import { Button } from '../ui/button';
import { MessageSquare, Pencil, Trash2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';

type WorkSessionActionsProps = {
    session: WorkSession;
    onEdit: (session: WorkSession) => void;
    onDelete: (session: WorkSession) => void;
    size?: "sm" | "md";
}

export const WorkSessionActions = ({ session, onEdit, onDelete, size = "sm" }: WorkSessionActionsProps) => {
    const isSm = size === "sm";

    const btnClass = isSm
    ? "h-7 w-7 border-border/80 bg-muted/50 text-muted-foreground shadow-sm hover:bg-accent hover:text-foreground"
    : "h-8 w-8 border-border/80 bg-muted/50 text-muted-foreground shadow-sm";

  const iconClass = isSm ? "h-3.5 w-3.5" : "h-3.5 w-3.5";

    return (
    <div className="flex shrink-0 items-center justify-end gap-1">
      {session.comment ? (
        <Dialog>
          <DialogTrigger asChild>
            <Button
              type="button"
              variant="outline"
              size="icon"
              title="Commentaire"
              className={btnClass}
            >
              <MessageSquare className={iconClass} />
            </Button>
          </DialogTrigger>
          <DialogContent className="sm:max-w-md">
            <DialogHeader>
              <DialogTitle>Commentaire</DialogTitle>
            </DialogHeader>
            <p className="whitespace-pre-wrap break-words text-sm text-muted-foreground">
              {session.comment}
            </p>
          </DialogContent>
        </Dialog>
      ) : null}
      <Button
        type="button"
        variant="outline"
        size="icon"
        title="Modifier"
        className={btnClass}
        onClick={() => onEdit(session)}
      >
        <Pencil className={iconClass} />
      </Button>
      <Button
        type="button"
        variant="outline"
        size="icon"
        title="Supprimer"
        className={
          btnClass +
          (isSm ? " hover:bg-destructive/10 hover:text-destructive" : " hover:text-destructive")
        }
        onClick={() => onDelete(session)}
      >
        <Trash2 className={iconClass} />
      </Button>
    </div>
  );
};

